import { MapsAPILoader } from '@agm/core';
import { Component, ElementRef, Inject, NgZone, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import swal from 'sweetalert2'

@Component({
  selector: 'app-user-location',
  templateUrl: './user-location.component.html',
  styleUrls: ['./user-location.component.scss']
})
export class UserLocationComponent implements OnInit {
  myForm!: FormGroup;
  city_value: any;
  country_value: any;
  city_final: any;
  public latitude: number;
  restoCondition
  public longitude: number;
  @ViewChild('city', { static: false }) public searchElementRef!: ElementRef;
  constructor(
    private fb: FormBuilder,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    private router: Router,
    public dialog: MatDialog,
  ) {
    this.createForm();
  }

  formattedAddress
  restoConditions
  lat
  lng
  ngOnInit(): void {




    this.mapsAPILoader.load().then(() => {
      let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
        types: ["geocode"]
      });
      autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          //get the place result
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();
          //verify result
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }
          this.formattedAddress = place.formatted_address;
          this.latitude = place.geometry.location.lat();
          this.longitude = place.geometry.location.lng();
          this.lat = sessionStorage.setItem('lat',JSON.stringify(this.latitude));
          this.lng = sessionStorage.setItem('lng',JSON.stringify(this.longitude));
          sessionStorage.setItem('userLocation',this.formattedAddress);
          sessionStorage.setItem('visitorOrigin',this.formattedAddress)
            this.restoConditions = "1";
            this.router.navigate(['/public/aggregator'])
          
        });
      });
    });
  }

  createForm() {
    this.myForm = this.fb.group({
      city: ['', Validators.required],
    });
  }

  clearValue() {
    this.myForm.reset();
  }

  showFilteredResto: boolean = false
  modelChanged(e, somename) {
    if (e.length >= 1) {
      this.showFilteredResto = true;
    } else {
      this.showFilteredResto = false;
    }
  }

  gotoRestoPage() {
    this.restoCondition = "2";
    this.router.navigate(['/public/aggregator'])
  }

  enableCurrentLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position: Position) => {
          if (position) {
            this.lat = position.coords.latitude;
            this.lng = position.coords.longitude;
  
            sessionStorage.setItem('lat', this.lat);
            sessionStorage.setItem('lng', this.lng);
          }
          this.gotoRestoPage();
        },
          (error: PositionError) => {
            const dialogRef = this.dialog.open(guestUserEnableLocation, {
              width: "321px",
              height: "163px"
            });
          });
      } else {
        swal.fire("Geolocation is not supported by this browser.");
      }
    }
}

@Component({
  selector: 'guest-user-enable-location',
  templateUrl: 'guest-user-enable-location.html',
})
export class guestUserEnableLocation implements OnInit {
  token
  constructor(
    public dialogRef: MatDialogRef<guestUserEnableLocation>,
    @Inject(MAT_DIALOG_DATA) public data,
    private _bottomSheet: MatBottomSheet,
    private router: Router
  ) { }
  ngOnInit(): void {

  }

  imsure(): void {
    this.dialogRef.close();
    // this.router.navigate(['/public/resto'])
  }

  retry() {
    this.dialogRef.close();
  }
}





